/* 库存调整 */
const stockadjust = {
  add:"/stockmng/stockadjust/add",//库存调整-入库
  out:"/stockmng/stockadjust/addout",//库存调整-出库
  materialStock:"/stockmng/stock/mtrlstock",//总库存
  mtrlstockbatch:"/stockmng/stock/mtrlstockbatch",//物料库存批次查找
  mtrlstockhistorybatch:"/stockmng/stock/mtrlstockhistorybatch",//物料历史库存批次查找
  find:"/stockmng/stockadjust/find",//查询库存调整单
  list:"/stockmng/stockadjust/queryout",//查询库存调整凭证列表
  query:"/stockmng/stockadjust/query"//查找库存调整明细列表
}

const saleOutStock = {
	list:"/salemng/saleorder/stocklist",//查询物料库存及销售价格列表
}

const salepricelist = {
  list:"/salemng/saleorder/salepricelist"//销售订单-查询销售价格列表
}

export{
	stockadjust,
  saleOutStock,
  salepricelist
}
